<template>
  <div class="row">
    <div class="col-md-6 col-md-offset-3">
      <div class="form-group">
        <label>{{ $t('marketingCoupons.selectCoupon') }}</label>
        <v-select v-model="selectedCoupon"
                  :options="coupons"
                  label="selectLabel"
                  :placeholder="$t('marketingCoupons.noCoupon')">
        </v-select>
        <small class="text-muted">{{ $t('marketingCoupons.selectCouponHelp') }}</small>
      </div>

      <div v-if="selectedCoupon" class="box coupon-select-step__summary">
        <p><b>{{ $t('marketingCoupons.code') }}:</b>
          <template v-if="selectedCoupon.coupon_has_multiple_codes">{{ $t('marketingCoupons.multipleCodes') }} ({{ selectedCoupon.coupons_codes_count || 0 }})</template>
          <template v-else>{{ selectedCoupon.coupon_code }}</template>
        </p>
        <p><b>{{ $t('marketingCoupons.discount') }}:</b>
          <template v-if="selectedCoupon.type === 'FREE_PRODUCT'">{{ $t('marketingCoupons.freeProduct') }}</template>
          <template v-else>{{ selectedCoupon.discount }} {{ selectedCoupon.type === 'FIXED' ? currency : '%' }}</template>
        </p>
        <p><b>{{ $t('marketingCoupons.validFromTo') }}:</b>
          {{ formatDate(selectedCoupon.datetime_validfrom) }} - {{ formatDate(selectedCoupon.datetime_validto) }}
        </p>
        <p class="text-danger" v-if="!selectedCoupon.active">{{ $t('marketingCoupons.couponInactive') }}</p>
        <p class="text-warning" v-if="isOutsideCampaign">{{ $t('marketingCoupons.couponOutsideCampaign') }}</p>
      </div>
    </div>
  </div>
</template>
<script>
  import moment from 'moment'
  // Step 3 of the push campaign wizard: the campaign only announces a coupon (campaigns.coupon_id).
  // Coupons themselves are managed in the Coupons tab.
  export default {
    props: {
      modelFromParent: {
        type: [Object, Array]
      }
    },
    data () {
      return {
        model: this.modelFromParent,
        coupons: [],
        couponsLoaded: false,
        selectedCoupon: null,
        currency: ''
      }
    },
    watch: {
      modelFromParent (value) {
        if (!value || Array.isArray(value) || typeof value !== 'object') {
          return
        }
        this.model = value
        if (value.coupon_id === undefined && this.selectedCoupon) {
          // a step copied the model without the coupon => keep the current selection
          this.$set(this.model, 'coupon_id', this.selectedCoupon.id)
          return
        }
        this.syncSelectedCoupon()
      },
      selectedCoupon (value) {
        if (this.couponsLoaded && this.model && typeof this.model === 'object' && !Array.isArray(this.model)) {
          this.$set(this.model, 'coupon_id', value ? value.id : null)
        }
      }
    },
    computed: {
      isOutsideCampaign () {
        const fromto = this.model && this.model.fromto
        if (!this.selectedCoupon || !fromto || !fromto[0] || !fromto[1]) {
          return false
        }
        const day = value => moment(value).format('YYYY-MM-DD')
        return day(fromto[0]) < String(this.selectedCoupon.datetime_validfrom).substr(0, 10) ||
          day(fromto[1]) > String(this.selectedCoupon.datetime_validto).substr(0, 10)
      }
    },
    created () {
      this.currency = this.getCurrencySymbol(this.$session.get('selectedCompanyData').currency_iso)
      this.getCoupons()
    },
    methods: {
      getCoupons () {
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        // subscription coupons apply only through a subscription: a campaign can't announce them
        data.exclude_subscription = 1
        // automatic marketing coupons are given only by automatic campaigns: a push campaign can't announce them
        data.exclude_automation = 1
        this.apiRequest('/coupon', 'GET', data, (response) => {
          if (response.status === true) {
            this.coupons = response.data.map(coupon => ({
              ...coupon,
              selectLabel: coupon.name + (coupon.coupon_code ? ' (' + coupon.coupon_code + ')' : '')
            }))
            this.couponsLoaded = true
            this.syncSelectedCoupon()
          }
        })
      },
      syncSelectedCoupon () {
        if (!this.couponsLoaded) {
          return
        }
        const couponId = this.model && this.model.coupon_id
        this.selectedCoupon = couponId
          ? this.coupons.find(coupon => coupon.id === parseInt(couponId, 10)) || null
          : null
      },
      validate () {
        return true
      }
    }
  }
</script>
<style>
  .coupon-select-step__summary {
    border: 1px solid #f2f2f2;
    padding: 10px 15px;
    margin-top: 10px;
  }
  .coupon-select-step__summary p {
    margin-bottom: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Campaigns/Steps/CouponSelectStep.vue